import BackButton from '../components/BackButton';
import { useApp } from '../App';
import { useState, useEffect } from 'react';
import api from '../api';
import Loading from '../components/Loading';
import { useI18n } from '../i18n/index.jsx';

export default function AdminApplications() {
  const { user } = useApp();
  const { t } = useI18n();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const { data } = await api.get('/admin/applications');
      setApps(data);
    } catch {}
    setLoading(false);
  }

  async function setStatus(id, status) {
    try {
      await api.post(`/admin/applications/${id}/status?status=${status}`);
      load();
    } catch {}
  }

  async function requestInfo(id) {
    const msg = prompt('Сообщение клиенту:');
    if (!msg) return;
    try {
      await api.post(`/admin/applications/${id}/request-info?message=${encodeURIComponent(msg)}`);
      load();
    } catch {}
  }

  const typeLabels = { oswiadczenie: '📝 Oświadczenie', zezwolenie: '📜 Zezwolenie', karta_pobytu: '🛂 Karta Pobytu' };

  if (loading) return <Loading />;

  return (
    <div className="page"><BackButton />
      <h1>📑 Все заявки ({apps.length})</h1>
      {apps.length === 0 ? <div className="empty">Нет заявок</div> :
        <div className="list">
          {apps.map(a => (
            <div key={a.id} className="list-item">
              <div className="list-main">
                <div className="list-title">{typeLabels[a.app_type] || a.app_type} #{a.id}</div>
                <div className="list-sub">Клиент: {a.client_id} • {a.created_at?.split('T')[0]}</div>
                {a.notes && <div className="list-sub" style={{fontSize:11,color:'#999'}}>{a.notes.substring(0,80)}</div>}
              </div>
              <div className="list-right">
                <div className={`status-badge status-${a.status}`}>{a.status}</div>
                <div className="admin-actions">
                  <button className="btn btn-tiny" onClick={() => setStatus(a.id, 'approved')}>✅</button>
                  <button className="btn btn-tiny" onClick={() => setStatus(a.id, 'rejected')}>❌</button>
                  <button className="btn btn-tiny" onClick={() => requestInfo(a.id)}>📎</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}
